import { useEffect } from "react";
import TrainingContent from "../components/Training/TrainingContent";
import PricingPlansSection from "../components/Training/PricingPlansSection";
import TrainingBanner from "../components/Training/TrainingBanner";

export default function Training() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <TrainingContent />
      <TrainingBanner />
      <PricingPlansSection />
    </>
  );
}